/**
 * Code block language configurations for MDX Editor
 * Maps language identifiers to display names
 */

export const codeBlockLanguages: Record<string, string> = {
  // Empty/plain text
  '': 'Plain Text',
  text: 'Text',

  // Web technologies
  html: 'HTML',
  xml: 'XML',
  css: 'CSS',

  // JavaScript ecosystem
  js: 'JavaScript',
  ts: 'TypeScript',
  json: 'JSON',

  // Backend languages
  php: 'PHP',
  python: 'Python',

  // Shell/scripting
  bash: 'Bash',
  sh: 'Shell',
  powershell: 'PowerShell',

  // Database
  sql: 'SQL',

  // Markup/config
  md: 'Markdown',
  yaml: 'YAML',
};

export default codeBlockLanguages;
